module.exports = __webpack_public_path__ + "media/images/top/package/package-link-1-7c45394d41df25394ae826a6c4519b67.png";